import Module, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import ActivityView from "./activity_view";
import PromiseUtility from "../../../../utility/promiseUtility";
import ActivityUtil, { ActivityCode } from "./activity_util";
import LanguageManager from "../../../../manager/language_manager";
import ModuleManager from "../../../../framework/core/module_manager";
import bindingCellphone from "../bindingCellphone/bindingCellphone";
import TextureManager from "../../../../manager/texture_manager";
import ModelData from "../../../public/model_data";
import AppData from "../../../public/const/app_data";

const { ccclass, property } = cc._decorator;


@ccclass
@moduleInit("Activity")
export default class Activity extends Module<ActivityView, null>{    

    //type: 1精彩活动 2游戏公告
    //showType
    //1活动 2公告 3广告图
    //8添加有礼 9收藏有礼 10邀请排行榜 11三人好友赛 12破产补助 13入群有礼
    _intenData = null
    _datas = null

    constructor() {
        super();
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/activity/activity";
        this.viewType = ActivityView
        this.modelType = null
        // this.autoShowAnim = true
        // this.needAnim = true
        this.needViewMask = true
        this.needViewBaseTitleBg = false
        this.needViewBaseBg = false
        this.needViewBaseCloseBtn = false
        this.needDeferShow = true
    }

    onInit(intenData) {
        this.eventBind('bind_cellphone_success', this.on_bind_cellphone_success)
    }

    onDeferShow(intenData) {
        let self = this
        let noticeData = intenData ? intenData.noticeData: null
        let tag = intenData ? intenData.tag: null
        let subTag = intenData ? intenData.subTag: null
        let onlyOne = intenData && intenData.onlyOne
        ModuleManager.instance.showModuleName("NetPrompt");
        this.getDatas(function (dataMap) {

          
            //外部模块嵌入到本地
            if(ModelData.instance.needBindSocialAccount){
                let bindData = {
                    _moduleName: 'ActivityExtent',
                    showRedPoint: ModelData.instance.needBindSocialAccount,
                    title: LanguageManager.t('activity_title_bind', true),
                    activity: "bind",
                }
                dataMap.listDataMap[0].push(bindData)
            }

            let activationData = {
                _moduleName: 'ActivityExtent',
                showRedPoint: ModelData.instance.isActivationAward,
                title: LanguageManager.t('activity_title_activation', true),
                activity: "code",
            }
            dataMap.listDataMap[0].push(activationData)
            // if(ModelData.instance.isAppScore){
            let scoreData = {
                _moduleName: 'ActivityExtent',
                showRedPoint: ModelData.instance.isAppScore,
                title: LanguageManager.t('activity_title_score', true),
                activity: "score",
            }
            dataMap.listDataMap[0].push(scoreData)
            // }

           
            let targetTopIndex = null
            let targetSubIndex = null
            self.view.showTopToggles([0, 1])
            if(tag == 'activity'){
                targetTopIndex = 0     
                if(onlyOne){
                    self.view.showTopToggles([])
                    dataMap.listDataMap = [dataMap.listDataMap[0], []]
                }
            }else if(tag == 'notice'){
                targetTopIndex = 1
                if(onlyOne){
                    self.view.showTopToggles([])
                    dataMap.listDataMap = [[], dataMap.listDataMap[1]]
                }
            }else{
                
            }

            let pointCountList = [0, 0]
            let selectInitedList = [false, false]
            for (let i = 0; i < dataMap.listDataMap.length; i++) {
                const dataList = dataMap.listDataMap[i];
                for (let j = 0; j < dataList.length; j++) {
                    const element = dataList[j];
                    if(targetTopIndex == i && subTag && targetSubIndex == null){
                        if(element.activity == subTag ||
                            element.activityName == subTag){
                                if(onlyOne){
                                    dataMap.listDataMap[i] = [element]
                                    targetSubIndex = 0
                                    break
                                }
                                targetSubIndex = j
                            }
                    }
                    let key = ActivityUtil.get_hide_red_point_key(i, element)
                    let hideRedPoint = ActivityUtil.getHideRedPointData(key)
                    if (!hideRedPoint || element.isReceive) {
                        if (!selectInitedList[i]) {
                            dataMap.selectIndexMap[i] = j
                            selectInitedList[i] = true
                        }
                        pointCountList[i]++
                    }
                }
            }
            if (dataMap.listDataMap[0].length == 0) {
                dataMap.topIndex = 1
            } else if (dataMap.listDataMap[1].length == 0) {
                dataMap.topIndex = 0
            } else {
                if(targetTopIndex != null){
                    dataMap.topIndex = targetTopIndex
                    if(targetSubIndex != null){
                        if(dataMap.selectIndexMap){
                            dataMap.selectIndexMap[targetTopIndex] = targetSubIndex
                        }else{
                            self.view.set_last_index(targetSubIndex, targetTopIndex)
                        }                                                
                    }
                }else{
                    if (pointCountList[1] == 0) {
                        dataMap.topIndex = 0
                    } else if (pointCountList[0] == 0) {
                        dataMap.topIndex = 1
                    } else {
                        dataMap.topIndex = 1
                    }
                }
                
            }

            ModuleManager.instance.hideModule("NetPrompt");
            self.view.showPanel(dataMap)
            // self.showAnim()
            self.show()
        }, noticeData)
    }


    protected getDatas(onFinish: Function, noticeData?) {
        let self = this
        let dataMap = {
            listDataMap: [
                [],
                [],
            ],
            topIndex: 1,
            selectIndexMap: [
                0,
                0,
            ],
        }

        let list = []
        list.push(function (cb) {
            ActivityUtil.getAllAcitvityData(function (dataList) {
                let tmpList = []
                for (let index = 0; index < dataList.length; index++) {
                    const data = dataList[index];
                    tmpList.push(function (cb1) {
                        TextureManager.instance.getSprite(data.activityDesc, (sprite) => {
                            if (self.node && self.isValid) {
                                cb1 && cb1()
                            }
                        })
                    })

                    dataMap.listDataMap[0].push(data)
                }
                PromiseUtility.all(tmpList).then(function () {
                    cb && cb()
                })
            }, function () {
                cb && cb()
            }, self)
        })
        if (noticeData) {
            dataMap.listDataMap[1] = noticeData
        } else {
            list.push(function (cb) {
                ActivityUtil.getNoticeData(function (data) {
                    dataMap.listDataMap[1] = data
                    cb && cb()
                }, function (retData) {
                    cb && cb()
                }, self)
            })
        }

        PromiseUtility.all(list).then(function () {
            onFinish && onFinish(dataMap)
        })
    }



    @bindButtonClickEvent("GetBtn")
    private on_click_get_btn() {
        let self = this
        if (self.view.curData) {
            ActivityUtil.requestDrawActivityAward(self.view.curData.activityId, function (data) {
                self.on_draw_award(data)
            }, function () {

            }, self)
        }
    }

    @bindButtonClickEvent('closeBtn')
    protected on_click_close_btn(){
        this.hide()
    }

    @bindButtonClickEvent('goBindBtn')
    private on_click_go_bind_btn() {
        ModuleManager.instance.showModule(bindingCellphone, { loginBinding: false });
    }


    private on_draw_award(data) {
        let self = this
        self.getDatas(function (dataMap) {
            dataMap.topIndex = null
            dataMap.selectIndexMap = null
            self.view.showPanel(dataMap)
        })
        self.getSelfCurrencyData(null, true)
        let chipNum = 0
        let goldNum = 0
        if (data && data.length > 0) {
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.activityAmountType == 5) {
                    chipNum += Number(element.amount)
                } else if (element.activityAmountType == 6) {
                    goldNum += Number(element.amount)
                }
            }
            ModuleManager.instance.showModuleName('DialogReceive', { chipNum: chipNum, goldNum: goldNum })
        }
    }

    private on_bind_cellphone_success() {
        let self = this
        self.getDatas(function (dataMap) {
            dataMap.topIndex = null
            dataMap.selectIndexMap = null
            self.view.showPanel(dataMap)
        })
    }

    protected hideExtentModule() {
        if (this.view && this.view.curData && this.view.curData._moduleName) {
            ModuleManager.instance.hideModule(this.view.curData._moduleName)
        }
    }

    protected onHide() {
        super.onHide()
        this.hideExtentModule()
    }

    on_destroy() {
        super.on_destroy()
        this.hideExtentModule()
    }
}